import {
  Location,
  LocationStrategy,
  PathLocationStrategy,
} from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalService } from "ngx-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import { AuthenticationService } from "../services/authentication.service";
import { Globals } from "../services/globals";
import { HelperService } from "../services/helper.service";
import { StylesService } from '../services/styles.service';

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
  providers: [
    AuthenticationService,
    Location,
    StylesService,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
  ],
})
export class LoginComponent implements OnInit {
  public model: any = {};
  public loading = false;
  public loginError = false;
  public returnUrl: string;
  private token: string = "";
  private username: string = "";
  public fieldTextType: boolean;
  public isLoginInitial: number = 0;
  public isLocalLogin: number = 0;
  public isAzureLogin: number = 0;
  usernotfound: boolean = false;
  errorMessage: string;

  constructor(
    private location: Location,
    private route: ActivatedRoute,
    private globals: Globals,
    private router: Router,
    private helperService: HelperService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService,
    private authenticationService: AuthenticationService,
    private stylesService: StylesService
  ) {}

  public ngOnInit() {
    this.returnUrl = "home"; //this.route.snapshot.queryParams['returnUrl'] || '/';
    // this.returnUrl = "dashboard"; //this.route.snapshot.queryParams['returnUrl'] || '/';
    //console.log(this.returnUrl);
    this.token = this.helperService.getRouterQueryParam(
      this.route.snapshot,
      "token"
    );
    this.username = this.helperService.getRouterQueryParam(
      this.route.snapshot,
      "username"
    );
    // reset login status
    if (this.token && this.username) {
      this.authenticationService.logout();
      this.loginWithToken();
    } else if (
      localStorage.getItem("access_token") ||
      localStorage.getItem("refresh_token")
    ) {
      this.checkUser();
    } else {
      this.authenticationService.logout();
    }
    this.usernotfound = this.helperService.getRouterQueryParam(
      this.route.snapshot,
      "usernotfound"
    );
    if (this.usernotfound) {
      this.loginError = true;
      this.errorMessage = "User not found in the system.";
    }
  }

  public loginWithToken() {
    const that = this;
    that.spinner.show();
    that.loading = true;
    that.authenticationService
      .loginWithToken(that.username, that.token)
      .subscribe(
        (data) => {
          that.redirect();
        },
        (error) => {
          // that.alertService.error(error);
          that.loading = false;
          this.loginError = true;
          if (error.status != 422) {
            this.errorMessage = error.error.message;
          }
          that.spinner.hide();
        }
      );
  }

  public login() {
    const that = this;
    if (that.model.username && that.model.password) {
      that.spinner.show();
      that.loading = true;
      that.authenticationService
        .login(that.model.username, that.model.password)
        .subscribe(
          (data) => {
            that.redirect();
          },
          (error) => {
            // that.alertService.error(error);
            that.loading = false;
            this.loginError = true;
            that.spinner.hide();
            that.errorMessage = error.error.message;
          }
        );
    } else {
      that.checkUserAzureAdEmployee();
    }
  }

  public redirect() {
    const that = this;
    this.authenticationService
      .getCurrentUserInfo()
      .get()
      .subscribe(
        (resp) => {
          that.spinner.hide();
          const data = resp.data;
          
          let theme=data.company.theme ? data.company.theme  : 'default';
          localStorage.setItem('theme', theme);
            this.stylesService.setGlobalStyles(theme);
       

          
          localStorage.setItem("selectedCompany", data.empCompanySystemID);
          if (that.globals.returnUrl != "") {
            if (Object.keys(that.globals.returnQueryParams).length != 0) {
              this.router.navigate([that.globals.returnUrl], {
                queryParams: that.globals.returnQueryParams,
              });
            } else {
              this.helperService.go(that.globals.returnUrl);
            }
            setTimeout(() => {
              that.globals.returnUrl = "";
              that.globals.returnQueryParams = {};
            }, 0);
          } else {
            if (
              data.isInitialLogin &&
              +this.helperService.getSelectedCompanyId() == 3
            ) {
              this.helperService.goToProfile();
            } else if (data.company && data.company.defaultLoadPage) {
              if (data.company.defaultLoadPage == 1) {
                // this.helperService.go("dashboard");
                that.helperService.go("home");
                // this.helperService.go("dms/document-explorer");
              } else if (data.company.defaultLoadPage == 2) {
                this.helperService.go("reports/leadership-board-report");
              } else {
                that.helperService.go("home");
                // this.helperService.go("dms/document-explorer");
              }
            } else {
              this.helperService.go(that.returnUrl);
            }
          }
        },
        (error) => {
          that.spinner.hide();
          this.loginError = true;
          that.errorMessage = error.data.message;
          that.authenticationService.logout();
        }
      );
  }

  checkUser() {
    const that = this;
    this.authenticationService
      .checkAuth()
      .get()
      .subscribe(
        (resp) => {
          // that.helperService.go("dashboard");
          that.helperService.go("home");
          // that.helperService.go("dms/document-explorer");
          //  that.redirect();
        },
        (error) => {
          if (localStorage.getItem("refresh_token")) {
            this.refreshToken();
          } else {
            this.authenticationService.logout();
          }
        }
      );
  }

  public checkUserAzureAdEmployee() {
    const that = this;
    that.spinner.show();
    that.isAzureLogin = 0;
    that.isLocalLogin = 0;
    that.model.password = "";
    that.loginError = false;
    this.authenticationService
      .checkLoggedEmployeeAzureUser()
      .get({
        username: that.model.username,
      })
      .subscribe(
        (resp) => {
          that.spinner.hide();
          that.isAzureLogin = resp.data.data.isAzureLogin;
          if (that.isAzureLogin == 1) {
            that.openAAD();
          } else {
            that.isLocalLogin = 1;
          }
        },
        (error) => {
          that.spinner.hide();
          that.loginError = true;
          that.errorMessage = error.data.message;
        }
      );
  }

  refreshToken() {
    const that = this;
    this.authenticationService.refreshToken().subscribe(
      (data) => {
        that.redirect();
      },
      (error) => {
        this.authenticationService.logout();
      }
    );
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  openAAD() {
    window.open("/aad/login", "_self");
  }
}



// WEBPACK FOOTER //
// /app/src/app/login/login.component.ts